import { render, staticRenderFns } from "./Detail-Proforma.vue?vue&type=template&id=197d2974"
import script from "./Detail-Proforma.vue?vue&type=script&lang=js"
export * from "./Detail-Proforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports